import React from 'react'
export const UserUpdatedAtContext = React.createContext()